import { Config, NodeEnv } from 'types/config';

export const CONFIG: Config = {
  NODE_ENV: (process.env.NODE_ENV ?? 'development') as NodeEnv,
  API_URL: import.meta.env.VITE_APP_API_URL,
  FORM_BUILDER_ADK_URL: import.meta.env.VITE_FORM_BUILDER_ADK_URL,
  PYLON_APP_ID: import.meta.env.VITE_APP_PYLON_APP_ID,
  MAP_API: import.meta.env.VITE_APP_MAP_API,
  APP_PLATFORM: import.meta.env.VITE_APP_PLATFORM,
  AMPLITUDE_KEY: import.meta.env.VITE_APP_AMPLITUDE_API_KEY,
  POSTHOG_KEY: import.meta.env.VITE_APP_POSTHOG_API_KEY,
  POSTHOG_HOST: import.meta.env.VITE_APP_POSTHOG_HOST,
  // SEGMENT_WRITE_KEY: import.meta.env.VITE_APP_SEGMENT_WRITE_KEY,
  // ANALYTICS_SEGMENT_WRITE_KEY: import.meta.env.VITE_APP_SEGMENT_WRITE_KEY,
  BASE_URL: import.meta.env.VITE_APP_BASE_URL,
  HANDSONTABLE_LICENSE_KEY: import.meta.env.VITE_APP_HANDSONTABLE_LICENSE_KEY,
  OTEL_COLLECTOR_URL: import.meta.env.VITE_APP_OTEL_COLLECTOR_URL ?? '',
  ENABLE_TRACING: import.meta.env.VITE_APP_ENABLE_TRACING ?? '',
  OTEL_TRACE_SAMPLE_RATIO:
    import.meta.env.VITE_APP_OTEL_TRACE_SAMPLE_RATIO ?? '1',
  OTEL_HEADERS: import.meta.env.VITE_APP_OTEL_HEADERS ?? '',
  QUARTERZIP_WORKSPACE_TOKEN: import.meta.env
    .VITE_APP_QUARTERZIP_WORKSPACE_TOKEN,
  QUARTERZIP_AGENT_ID: import.meta.env.VITE_APP_QUARTERZIP_AGENT_ID ?? '',
} as const;
